var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{directives:[{name:"focus",rawName:"v-focus"}]}),_vm._v(" "),_c('span',[_vm._v("title:"+_vm._s(_vm.title))]),_vm._v(" "),_c('span',[_vm._v("author:"+_vm._s(_vm.author))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3df17b2e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/udesk-Input-Test.vue
// module id = 4
// module chunks = 0